<template>
  <vue-scroll :ops="scrollBar">
        <div class="accordion" role="tablist" style="height:90%">
    <b-card no-body class="m-3">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.driverDoc variant="info">Driver Documents</b-button>
      </b-card-header>
      <b-collapse id="driverDoc" accordion="my-accordion" role="tabpanel" @input="setDriverLoading">
        <b-card-body class="p-2">
          <driverDocumentsList :driverId="driverId" @updatedCount="docCountChanged"/>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="m-3">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.vehicleDoc variant="info">Vehicle Documents</b-button>
      </b-card-header>
      <b-collapse id="vehicleDoc" accordion="my-accordion" role="tabpanel" @input="setVehicleLoading">
        <b-card-body class="p-2">
          <vehicleDocumentsList :driverId="driverId" :defaultCar="defaultCar" @updatedCount="docCountChanged"/>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
  </vue-scroll>
</template>

<script>
import driverDocumentsList from "./driverDoc";
import vehicleDocumentsList from "./vehicleDoc";
export default {
  name: "driverDocuments",
  components:{
      driverDocumentsList,
      vehicleDocumentsList
  },
  props:{
      driverId: String,
      defaultCar:String
  },
  data() {
    return {
      isVehicleLoad:false,
      isDriverLoad:false

    };
  },
  computed:{
      scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  methods:{
      setDriverLoading(visible){
          this.isDriverLoad=visible;
      },
      setVehicleLoading(visible){
          this.isVehicleLoad=visible;
      },
      docCountChanged(ob){
        this.$emit("updated", ob);
      }
  }
};
</script>